import Sortable from 'sortablejs';

$(() => {
  $('.js-part-input').each(function () {
    const $root = $(this)

    // 二重初期化防止
    if ($root.data('initialized')) return
    $root.data('initialized', true)

    const scope = $root.data('scope') // ★ 追加
    if (!scope) return

    const $list = $root.find('.js-part-input-list')
    const templateHtml = $root.find('.js-part-input-template').html()
    if (!templateHtml) return

    /* =====================
       util
       ===================== */

    const nextIndex = () => $list.children('.js-part-item').length

    // [] や [ を正規表現用にエスケープ
    const escapeForRegex = (str) =>
      str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')

    const scopeRegex = escapeForRegex(scope)

    const buildName = (index, attr, isArray = false) =>
      `${scope}[${index}][${attr}]${isArray ? '[]' : ''}`

    /* =====================
       template → list（追加直後）
       ===================== */

    const rewriteNames = ($scope, index) => {
      $scope.find('input, select, textarea').each(function () {
        const $el = $(this)
        let name = $el.attr('name')
        if (!name) return

        // checkbox の [] 判定
        const isArray = name.endsWith('[]')
        if (isArray) name = name.replace(/\[\]$/, '')

        // template 側は name="str_1" など
        const attr = name

        $el.attr('name', buildName(index, attr, isArray))
      })
    }

    /* =====================
       並び替え / 削除後の再採番
       ===================== */

    const fixInputs = () => {
      $list.children('.js-part-item').each(function (i) {
        const $item = $(this)

        /* ---- name 再構築 ---- */
        $item.find('input, select, textarea').each(function () {
          const $el = $(this)

          // 触らない項目
          if ($el.hasClass('js-part-id')) return
          if ($el.hasClass('js-spec-code')) return

          let name = $el.attr('name')
          if (!name) return

          const m = name.match(
            new RegExp(`^${scopeRegex}\\[\\d+\\]\\[([^\\]]+)\\](\\[\\])?$`)
          )
          if (!m) return

          const attr = m[1]
          const isArray = !!m[2]

          $el.attr('name', buildName(i, attr, isArray))
        })

        /* ---- radio / checkbox の id / label[for] ---- */
        $item.find('input[type=radio], input[type=checkbox]').each(function () {
          const $input = $(this)
          const name = $input.attr('name')
          if (!name) return

          const m = name.match(/\[([^\]]+)\](\[\])?$/)
          if (!m) return

          const attr = m[1]
          const value = $input.val() ?? 'v'
          const type = $input.attr('type')

          const newId = `profile_parts_${i}_${attr}_${type}_${value}`
          const oldId = $input.attr('id')

          $input.attr('id', newId)

          if (oldId) {
            $item.find(`label[for="${oldId}"]`).attr('for', newId)
          }
        })

        /* ---- index 表示 ---- */
        $item.find('.js-part-item-index').each(function () {
          $(this).text(i + 1)
        })
      })
    }

    /* =====================
       追加
       ===================== */

    $root.on('click', '.js-add-part-input', function (e) {
      e.preventDefault()

      const index = nextIndex()
      const html = templateHtml.replace(/NEW_RECORD/g, index)
      $list.append(html)

      const $item = $list.children('.js-part-item').last()
      rewriteNames($item, index)

      fixInputs()
    })

    /* =====================
       削除
       ===================== */

    $root.on('click', '.js-remove-part-input', function (e) {
      e.preventDefault()
      const $item = $(this).closest('.js-part-item')

      if ($item.find('input[name$="[id]"]').length === 0) {
        $item.remove()
      } else {
        $item.find('.js-destroy-flag').val('1')
        $item.hide()
      }

      // 削除後にバリデーションしない
      $item.addClass('js-validate-skip')

      fixInputs()
    })

    /* =====================
       Sortable
       ===================== */

    if ($list.length) {
      new Sortable($list[0], {
        animation: 150,
        onEnd: () => fixInputs()
      })
    }

    /* =====================
       初期化
       ===================== */

    fixInputs()
  })
})
